import { c as _c } from "react/compiler-runtime";
import snapppayLogo from "@website/accommodation-ui/hotel-snapp-pay/assets/snapppay-logo.svg";
import { hotelSnappPayBadgePropertiesType } from "@website/accommodation-ui/hotel-snapp-pay/hotel-snapp-pay-badge/hotel-snapp-pay-badge.types";
import { LazyImage } from "@website/ui/lazy-image";
import { Skeleton } from "@website/ui/skeleton";
import { numberConvert } from "@website/utils/number-convert";
import { numberSeparator } from "@website/utils/number-separator";
export const HotelSnappPayBadge = t0 => {
  const $ = _c(7);
  const {
    isEligible,
    showDownPayment,
    loading,
    markup,
    price,
    page: t1
  } = t0;
  const page = t1 === undefined ? "cityPage" : t1;
  let t2;
  if ($[0] !== isEligible || $[1] !== loading || $[2] !== markup || $[3] !== page || $[4] !== price || $[5] !== showDownPayment) {
    t2 = isEligible && showDownPayment ? <div className={`${page === "cityPage" ? "h-[36px] w-full md:h-[32px] md:rounded-lg" : "h-[32px] lg:max-w-[275px] lg:rounded-lg"} text-ventures-fin-tech text-caption flex flex-row justify-between !bg-[#008EFA12] px-4 py-2`}><div className="flex flex-row gap-2"><div className="bg-ventures-fin-tech size-[16px] rounded-sm py-1.5 text-center"><LazyImage src={snapppayLogo?.src} /></div><div className="whitespace-nowrap"> رزرو با قسط اول از</div></div><div className="flex w-1/2 flex-row justify-end gap-1">{loading ? <Skeleton height={16} shape="rectangle" /> : <span>{markup && price && numberConvert(numberSeparator(markup * price / 4), {
            locale: "fa"
          })}</span>}<span>تومان</span></div></div> : null;
    $[0] = isEligible;
    $[1] = loading;
    $[2] = markup;
    $[3] = page;
    $[4] = price;
    $[5] = showDownPayment;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};